import React, {useContext} from 'react';
import './Profile.less';
import {ProfileGeneral} from "compositions/profile-general/ProfileGeneral";
import {ProfileDiscounts} from "compositions/profile-discounts/ProfileDiscounts";
import {PseudoPagePopup} from "dialog-layout/pseudo-page-popup/PseudoPagePopup";
import {Block} from "compositions/block/Block.tsx";
import {Card} from "elements/card/Card.tsx";
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {CardStyles} from "../../elements/card/Card";

export const PROFILE_POPUP = 'PROFILE_POPUP';

export const Profile = ({
													currentCustomer,
													isPromotionCodesInApp,
													cashBackPercentage,
													cashpointsAmount,
													cashpointsName,
													onPhoneClick,
													onNameClick,
													onEmailClick,
													onBirthdayClick,
													onCashpointsClick,
													onOffersClick,
													onOverlayClick,
													onCardClick
												}) => {

	const translations = useContext(TranslationsContext);

	const notSelectedLabel = getSafeTranslation('ProfilePopup.notSelectedPickerCaption', translations);

	const isShowCashpoints = typeof cashBackPercentage === 'number' && cashBackPercentage > 0;

	return <PseudoPagePopup
		title={getSafeTranslation('ProfilePopup.title', translations)}
		onBackClick={onOverlayClick}
	>
		<div className="profile">
			<div className="profile__general">
				<Block
					title={getSafeTranslation('ProfilePopup.generalBlockTitle', translations)}
					isNonScalable
				>
					<Card style={CardStyles.NESTED} isNoPaddings>
						<ProfileGeneral
							phone={currentCustomer?.phone || notSelectedLabel}
							onPhoneClick={!currentCustomer?.phone && onPhoneClick}
							name={currentCustomer?.nickname || notSelectedLabel}
							onNameClick={onNameClick}
							email={currentCustomer?.email || notSelectedLabel}
							onEmailClick={onEmailClick}
							birthday={currentCustomer?.birthdate || notSelectedLabel}
							onBirthdayClick={onBirthdayClick}
							card={currentCustomer?.cardNumber || notSelectedLabel}
							onCardClick={onCardClick}
						/>
					</Card>
				</Block>
			</div>
			{
				(isPromotionCodesInApp || isShowCashpoints) && (
					<div className="profile__discounts">
						<Block
							title={getSafeTranslation('ProfilePopup.discountsBlockTitle', translations)}
							isNonScalable
						>
							<Card style={CardStyles.NESTED} isNoPaddings>
								<ProfileDiscounts
									isShowCashpoints={isShowCashpoints}
									cashpointsAmount={cashpointsAmount}
									cashpointsName={cashpointsName}
									onCashpointsClick={onCashpointsClick}
									isShowOffers={isPromotionCodesInApp}
									offersCount={currentCustomer?.customerDiscounts && currentCustomer?.customerDiscounts.length}
									onOffersClick={onOffersClick}
								/>
							</Card>
						</Block>
					</div>
				)
			}

		</div>
	</PseudoPagePopup>
}
